import React from 'react';
import { Link } from 'react-router-dom';
import LearnLayout from '../../components/learn/LearnLayout';
import { usePageMeta } from '../../hooks/usePageMeta';
import { useSsrLearnRoute } from '../../hooks/useSsrLearnRoute';
import { getLearnManifest, regions } from '../../content/learn/registry';

function LearnRegionsIndex() {
  const manifest = getLearnManifest();
  useSsrLearnRoute('/learn/regions');
  usePageMeta({
    title: manifest.regions.index.title,
    description: manifest.regions.index.description,
    canonicalPath: manifest.regions.index.path,
  });

  return (
    <LearnLayout
      title="Report scams by country"
      description="Official links to report fraud, cybercrime, and unwanted calls."
      breadcrumb={
        <>
          <Link to="/learn" className="hover:underline">
            Safety guides
          </Link>
          {' / Regions'}
        </>
      }
    >
      <p className="text-gray-700 mb-8">
        Reporting helps authorities track trends and may support investigations. Links open
        official government or regulator sites in a new tab.
      </p>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {regions.map((r) => (
          <li key={r.code}>
            <Link
              to={`/learn/regions/${r.code}`}
              className="flex items-center gap-3 p-5 bg-white rounded-lg shadow border border-gray-100 hover:border-blue-200"
            >
              <span className="text-2xl" aria-hidden>
                {r.flag}
              </span>
              <div>
                <h2 className="font-semibold text-gray-900">{r.name}</h2>
                <p className="text-sm text-gray-500">
                  {r.resources.length} official resource
                  {r.resources.length === 1 ? '' : 's'}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </LearnLayout>
  );
}

export default LearnRegionsIndex;
